import { useMemo } from 'react'
import { renderToString } from 'react-dom/server'
import { PlacesType } from 'react-tooltip'

export type HTMLTooltipProps = {
  'data-tooltip-id'?: string
  'data-tooltip-place'?: PlacesType
  'data-tooltip-html'?: string | null
  'data-tooltip-delay-show'?: number
}

export type TooltipProps = {
  place?: PlacesType
  content?: React.ReactNode
  // Almost never needed because <Tooltip id="tooltip" /> is already in root
  id?: string
  // Delay in milliseconds before showing the tooltip
  delayShow?: number
}

export const useToolTip = ({
  content,
  id = 'tooltip',
  place = 'bottom',
  delayShow = 0,
}: TooltipProps): HTMLTooltipProps => {
  const tooltipHtml = useMemo(() => {
    let component = content
    if (content === null || content === undefined) {
      component = ''
    }
    if (typeof content === 'string') {
      const lines = content.trim().split('\n')
      component = (
        <div>
          {lines.map((line, index) => (
            <span key={index}>
              {line}
              {index < lines.length - 1 && <br />}
            </span>
          ))}
        </div>
      )
    }
    return typeof component === 'object' ? renderToString(component) : component
  }, [content])

  if (!content) {
    return {}
  }

  return {
    'data-tooltip-id': id,
    'data-tooltip-place': place,
    'data-tooltip-html': tooltipHtml as string | null,
    'data-tooltip-delay-show': delayShow,
  }
}
